import React, { useState, useEffect } from 'react';
import CodBloqueadosService from '../services/CodBloqueadosService';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';

export default function CodBloqueados() {
    const [isLoading, setIsLoading] = useState(false); // Estado de carregamento
    const [isNovoCadastro, setIsNovoCadastro] = useState(false); // Estado de carregamento
    const [codigos, setCodigos] = useState([]);
    const [search, setSearch] = useState('');
    const [newCodigo, setNewCodigo] = useState('');
    const [referencia, setReferencia] = useState('');
    const [descricao, setDescricao] = useState('');
    const [fornecedor, setFornecedor] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(15);
    const [totalPages, setTotalPages] = useState(1);

    const [showLogsModal, setShowLogsModal] = useState(false);
    const [logsModalContent, setLogsModalContent] = useState([]);


    const fetchCodigos = async (searchTerm = '', page = 1) => {
        try {
            const response = await CodBloqueadosService.getCodBloqueados(searchTerm, page, itemsPerPage);
            if (response) {
                setCodigos(response.codigos);
                setTotalPages(response.totalPages);
            } else {
                toast.error('Erro ao buscar os códigos.');
            }
        } catch (error) {
            toast.error('Erro ao buscar os códigos.');
        }
    };

    useEffect(() => {
        fetchCodigos(); // Busca inicial
    }, []);

    const handleSearch = async () => {
        setCurrentPage(1);
        fetchCodigos(search, 1);
    };

    const handleClearSearch = async () => {
        setSearch('');
        setCurrentPage(1);
        fetchCodigos('', 1);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchCodigos(search, page);
    };

    const handleRemoveCodigo = async (codigoId) => {
        const confirm = window.confirm('Tem certeza que deseja remover este código?');
        if (!confirm) return;

        try {
            const response = await CodBloqueadosService.removeCodBloqueado(codigoId);
            if (response && response.message) {
                toast.success(response.message);
                fetchCodigos(search, currentPage); // Recarrega a tabela após a remoção
            } else {
                toast.error('Erro ao remover o código.');
            }
        } catch (error) {
            toast.error('Erro ao remover o código.');
        }
    };

    const handleAddCodigo = async () => {
        if (!newCodigo.trim()) {
            toast.warning('O campo Código SAP não pode estar vazio.');
            return;
        }

        try {
            const response = await CodBloqueadosService.createCodBloqueado({
                codigo: newCodigo.trim(),
                referencia: referencia.trim(),
                descricao: descricao.trim(),
                fornecedor: fornecedor.trim(),
            });
            if (response && response.message) {
                toast.success(response.message);
                setNewCodigo('');
                setReferencia('');
                setDescricao('');
                setFornecedor('');
                fetchCodigos(search, currentPage); // Atualiza a lista
                setIsNovoCadastro(false);
            } else {
                toast.error('Erro ao adicionar o código.');
            }
        } catch (error) {
            toast.error('Erro ao adicionar o código.');
        }
    };

    const handleActivateCodigo = async (codigoId) => {
        try {
            const response = await CodBloqueadosService.activateCodBloqueado(codigoId);
            if (response && response.message) {
                toast.success(response.message);
                fetchCodigos(search, currentPage); // Atualiza a lista após a ativação
            } else {
                toast.error('Erro ao ativar o código.');
            }
        } catch (error) {
            toast.error('Erro ao ativar o código.');
        }
    };
    
    const handleDeactivateCodigo = async (codigoId) => {
        try {
            const response = await CodBloqueadosService.deactivateCodBloqueado(codigoId);
            if (response && response.message) {
                toast.success(response.message);
                fetchCodigos(search, currentPage); // Atualiza a lista após a desativação
            } else {
                toast.error('Erro ao desativar o código.');
            }
        } catch (error) {
            toast.error('Erro ao desativar o código.');
        }
    };
    

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        setIsLoading(true); // Ativa o indicador de carregamento
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

            jsonData.shift();

            const codigos = jsonData.map((row) => ({
                codSap: row[0],
                referencia: row[1],
                descricao: row[2],
                fornecedor: row[3],
            }));

            const chunkSize = 500;
            const totalChunks = Math.ceil(codigos.length / chunkSize);

            try {
                for (let i = 0; i < totalChunks; i++) {
                    const chunk = codigos.slice(i * chunkSize, (i + 1) * chunkSize);
                    await CodBloqueadosService.importarCodigosBloqueados(chunk);
                }
                toast.success('Importação concluída!');
            } catch (error) {
                toast.error('Erro durante a importação.');
            } finally {
                setIsLoading(false); // Desativa o indicador de carregamento
            }

            fetchCodigos(); // Atualiza a lista após a importação
        };

        reader.readAsArrayBuffer(file);
    };

    // Função para abrir modal de logs
    const handleShowLogs = (logs) => {
        setLogsModalContent(logs);
        setShowLogsModal(true);
    };
    

    return (
        <div className="flex w-full h-full justify-center items-center py-2 px-2 bg-gray-200">
            <div className="flex flex-col w-full h-full rounded-lg py-4 px-4 gap-4 bg-white">
                <div className="flex items-center gap-2 w-full text-sm font-semibold ps-2 mt-2">
                    CÓDIGOS BLOQUEADOS
                </div>
                {/* Busca e Cadastro */}
                <div className="flex flex-col gap-2">
                    {/* Pesquisa */}
                    <div className="flex space-x-2 text-[10px]">
                        <div className="flex flex-col">
                            <label className="font-semibold ms-1">Pesquisar</label>
                            <input
                                type="text"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                placeholder="Buscar código..."
                                className="block w-full rounded-xl px-2 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none"
                            />
                        </div>
                        <div className="flex items-end space-x-1">
                            <button
                                onClick={handleSearch}
                                className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-xl text-[10px]"
                            >
                                Pesquisar
                            </button>
                            <button
                                onClick={handleClearSearch}
                                className="bg-gray-500 hover:bg-gray-600 text-white px-3 py-1 rounded-xl text-[10px]"
                            >
                                Limpar
                            </button>
                            <label
                                htmlFor="file-upload"
                                className={`${isLoading ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-500 hover:bg-green-600'
                                    } text-white px-3 py-1 rounded-xl text-[10px] cursor-pointer`}
                            >
                                {isLoading ? 'Carregando...' : 'Importação'}
                            </label>
                            <input
                                id="file-upload"
                                type="file"
                                onChange={handleFileUpload}
                                className="hidden"
                                disabled={isLoading}
                            />
                            {isLoading && (
                                <div className="flex justify-center items-center">
                                    <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-blue-500"></div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div>
                        <button className="bg-black hover:bg-gray-900 text-white px-3 py-1 rounded-xl text-[10px]" onClick={()=>setIsNovoCadastro(!isNovoCadastro)}>
                            + Novo Cadastro
                        </button>
                    </div>
                    
                    {/* Novo Cadastro */}
                    {isNovoCadastro &&
                        <div className="flex flex-col gap-2 px-3 py-3 rounded-xl border border-gray-400 text-[10px]">
                            <div className="font-semibold">Novo Cadastro</div>
                            <div className="flex flex-wrap gap-2">
                                <div className="flex flex-col w-full md:w-1/5">
                                    <label className="font-semibold ms-1">Código SAP</label>
                                    <input
                                        type="text"
                                        value={newCodigo}
                                        onChange={(e) => setNewCodigo(e.target.value)}
                                        placeholder="Código SAP"
                                        className="block w-full rounded-xl px-2 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none"
                                    />
                                </div>
                                <div className="flex flex-col w-full md:w-1/5">
                                    <label className="font-semibold ms-1">Referência</label>
                                    <input
                                        type="text"
                                        value={referencia}
                                        onChange={(e) => setReferencia(e.target.value)}
                                        placeholder="Referência"
                                        className="block w-full rounded-xl px-2 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none"
                                    />
                                </div>
                                <div className="flex flex-col w-full md:w-1/5">
                                    <label className="font-semibold ms-1">Descrição</label>
                                    <input
                                        type="text"
                                        value={descricao}
                                        onChange={(e) => setDescricao(e.target.value)}
                                        placeholder="Descrição"
                                        className="block w-full rounded-xl px-2 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none"
                                    />
                                </div>
                                <div className="flex flex-col w-full md:w-1/5">
                                    <label className="font-semibold ms-1">Fornecedor</label>
                                    <input
                                        type="text"
                                        value={fornecedor}
                                        onChange={(e) => setFornecedor(e.target.value)}
                                        placeholder="Fornecedor"
                                        className="block w-full rounded-xl px-2 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none"
                                    />
                                </div>
                                <div className="flex items-end w-full md:w-auto">
                                    <button
                                        onClick={handleAddCodigo}
                                        className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded-xl text-[10px]"
                                    >
                                        Cadastrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    }
                </div>




                {/* Tabela */}
                <div className="overflow-x-auto min-h-48">
                    <table className="min-w-full bg-white rounded-lg text-[10px]">
                        <thead className="text-black" style={{ backgroundColor: '#e5e7eb' }}>
                            <tr>
                                <th className="py-2 px-4 border-b rounded-tl-lg">Código</th>
                                <th className="py-2 px-4 border-b">Referência</th>
                                <th className="py-2 px-4 border-b">Descrição</th>
                                <th className="py-2 px-4 border-b">Fornecedor</th>
                                <th className="py-2 px-4 border-b">Última ação</th>
                                <th className="py-2 px-4 border-b rounded-tr-lg">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {codigos.map((codigo, index) => (
                                <tr
                                    key={codigo._id}
                                    className={`border-t hover:bg-gray-100 ${codigo.status === 'BLOQUEADO' ? 'bg-red-50' : ''
                                        }`}
                                >
                                    <td className="py-1 px-4">{codigo.codSap}</td>
                                    <td className="py-1 px-4">{codigo.referencia}</td>
                                    <td className="py-1 px-4">{codigo.descricao}</td>
                                    <td className="py-1 px-4">{codigo.fornecedor}</td>
                                    <td className="py-1 px-4">
                                        {/* Mostra o último log do array logs como link */}
                                        {Array.isArray(codigo.logs) && codigo.logs.length > 0 ? (
                                            <button
                                                className="text-blue-600 underline cursor-pointer"
                                                onClick={() => handleShowLogs(codigo.logs)}
                                                title="Ver todos os logs"
                                                style={{ background: "none", border: "none", padding: 0, fontSize: "inherit" }}
                                                type="button"
                                            >
                                                {codigo.logs[codigo.logs.length - 1]}
                                            </button>
                                        ) : (
                                            "-"
                                        )}
                                    </td>
                                    <td className="py-1 px-4">
                                        <div className="flex justify-center gap-2 h-5 text-[11px]">
                                            {codigo.status === 'BLOQUEADO' ? (
                                                <button
                                                    className="flex items-center justify-center gap-1 bg-green-500 rounded-full px-2 text-white w-16"
                                                    onClick={() => handleActivateCodigo(codigo._id)}
                                                >
                                                    Ativar
                                                </button>
                                            ) : (
                                                <button
                                                    className="flex items-center justify-center gap-1 bg-red-500 rounded-full px-2 text-white w-16"
                                                    onClick={() => handleDeactivateCodigo(codigo._id)}
                                                >
                                                    Desativar
                                                </button>
                                            )}
                                            {/* <button
                                                className="flex items-center gap-1 bg-red-500 rounded-full px-2 text-white"
                                                onClick={() => handleRemoveCodigo(codigo._id)}
                                            >
                                                Remover
                                            </button> */}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>




                {/* Controle de Paginação */}
                <div className="flex justify-center items-center mt-4 gap-2 text-xs">
                    <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        className={`px-2 py-1 rounded-md ${currentPage === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
                    >
                        {'<'}
                    </button>

                    {/* Botão para a primeira página */}
                    {currentPage > 2 && (
                        <>
                            <button
                                onClick={() => handlePageChange(1)}
                                className="px-2 py-1 rounded-md bg-gray-300"
                            >
                                1
                            </button>
                            {currentPage >= 3 && <span className="px-2 py-1">...</span>}
                        </>
                    )}

                    {/* Botões ao redor da página atual */}
                    {Array.from({ length: 3 }, (_, i) => {
                        const page = currentPage - 1 + i;
                        if (page > 0 && page <= totalPages) {
                            return (
                                <button
                                    key={page}
                                    onClick={() => handlePageChange(page)}
                                    className={`px-2 py-1 rounded-md ${page === currentPage ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                                >
                                    {page}
                                </button>
                            );
                        }
                        return null;
                    })}

                    {/* Botão para a última página */}
                    {currentPage < totalPages - 1 && (
                        <>
                            {currentPage < totalPages - 2 && <span className="px-2 py-1">...</span>}
                            <button
                                onClick={() => handlePageChange(totalPages)}
                                className="px-2 py-1 rounded-md bg-gray-300"
                            >
                                {totalPages}
                            </button>
                        </>
                    )}

                    {/* Botões de navegação */}

                    <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className={`px-2 py-1 rounded-md ${currentPage === totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
                    >
                        {'>'}
                    </button>
                </div>

            </div>

            {/* Modal de logs */}
            {showLogsModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
                    <div className="bg-white rounded-lg shadow-lg min-w-[320px] max-w-[90vw]">
                        <div className="flex justify-between items-center mb-4 bg-gray-800 rounded-t-lg px-4 py-2">
                            <h2 className="text-lg font-bold text-white">Histórico</h2>
                            <button
                                className="text-gray-300 hover:text-gray-100 text-xl"
                                onClick={() => setShowLogsModal(false)}
                            >
                                &times;
                            </button>
                        </div>
                        <div className="max-h-80 overflow-y-auto pb-2">
                            {logsModalContent.length > 0 ? (
                                <table className="min-w-full text-sm">
                                    {/* <thead>
                                        <tr className="bg-gray-100">
                                            <th className="px-4 py-2 text-left">#</th>
                                            <th className="px-4 py-2 text-left">Log</th>
                                        </tr>
                                    </thead> */}
                                    <tbody>
                                        {logsModalContent.map((log, idx) => (
                                            <tr key={idx} className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                                                <td className="px-4 py-2">{idx + 1}</td>
                                                <td className="px-4 py-2">{log}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : (
                                <div className="text-gray-400">Nenhum log disponível.</div>
                            )}
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}
